import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './CopyForm.html?raw';
import on from 'dojo/on';

import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import '../../../moreCore/UI/GenericDialog/GenericDialog';
import { EvBookingView, OverlappingBookingsView } from "../../_loadingHelpers/VAMv2";
import { VAM2types } from "../../_loadingHelpers/VAMv2Types";
import DateTimeInput from '../../../moreCore/UI/DateTimeInput/DateTimeInput';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import Edit from '../../../moreCore/UI/Edit/Edit';
import "../../../moreCore/UI/Edit/Edit";
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import { ToasterHelpers } from "../../../more/Helpers";


interface DateSetRegistry {
    dateSet: VAM2types.DateSet,
    row: StaticTable.StaticTableRowGroup<DateSetRegistry>
    inputDateStart: any,
    inputDateEnd: any,
    inputFulltime: any,
    overlappingView: MdsLax<InstanceType<typeof OverlappingBookingsView>>,
    overlappingDlg: MdsLax<InstanceType<typeof GenericDialog>>,
    guid: string
}
class EvBookingCopyForm extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private headingText: HTMLElement;
    private datesetContainer: HTMLElement;
    private sectionTargetDates: HTMLElement;

    private activityStatusInput: MdsLax<InstanceType<typeof SearchSelect>>;
    private bookingStatusInput: MdsLax<InstanceType<typeof SearchSelect>>;
    private roomInput: MdsLax<InstanceType<typeof HintBox>>;
    private evProjectInput: MdsLax<InstanceType<typeof HintBox>>;
    private bookingTitleInput: MdsLax<InstanceType<typeof Edit>>;

    private datesTable: MdsLax<InstanceType<typeof StaticTable>>;
    private cbEvCast: MdsLax<InstanceType<typeof CheckBox>>;
    private containerEvCast: HTMLElement;
    private cbEvProgram: MdsLax<InstanceType<typeof CheckBox>>;
    private containerEvProgram: HTMLElement;
    private cbEvService: MdsLax<InstanceType<typeof CheckBox>>;
    private containerEvService: HTMLElement;
    private cbEvTask: MdsLax<InstanceType<typeof CheckBox>>;
    private containerEvTask: HTMLElement;

    private datesRegistry: Array<DateSetRegistry>;

    private formData: VAM2types.CopyFormData_EvBooking = null;

    private dlg: MdsLax<InstanceType<typeof GenericDialog>>;

    private _sourceBooking: {
        ID: string,
        dateStart: Date,
        dateEnd: Date,
        fullTime: boolean,
        ref_ev_activity_status: Object,
        ref_ev_booking_status: Object
    } = null;

    private _onChange_Any(value?: any) {
        this.delayedSerializeData(50);
    }
    private _onChange_Room(value?: any) {
        this.delayedSerializeData(50);
        for (let entry of this.datesRegistry) {
            this.setOverlappingViewParametersForEntry(entry);
        }
    }
    private _onClick_AddDateset(evt: MouseEvent) {
        this.addDateSet();
    }

    private addDateSet() {
        let set: VAM2types.DateSet = {
            dateStart: this._sourceBooking.dateStart,
            dateEnd: this._sourceBooking.dateEnd,
            isFulltime: this._sourceBooking.fullTime
        };

        let reg: DateSetRegistry = {
            dateSet: set,
            row: null,
            inputDateStart: null,
            inputDateEnd: null,
            inputFulltime: null,
            overlappingView: null,
            overlappingDlg: null,
            guid: (Math.random() * 100000000).toFixed(0)
        };

        if (this.hasFeature("EvBooking/Overlappings")) {
            reg.overlappingView = new OverlappingBookingsView();
            reg.overlappingView.on("dataReceived", lang.hitch(this, this._onOverlappingDataReceived, reg));

            this.setOverlappingViewParametersForEntry(reg);


        }

        this.datesRegistry.push(reg);

        this.drawDatesetTable();

        this.delayedSerializeData();
    }

    private _serializeHandle: any = null;
    private delayedSerializeData(delay: number = 200) {
        if (this._serializeHandle != null) {
            clearTimeout(this._serializeHandle);
            this._serializeHandle = null;
        }

        this._serializeHandle = setTimeout(lang.hitch(this, this.serializeData), delay);
    }
    private serializeData() {
        this._serializeHandle = null;

        if (!this._sourceBooking) return;


        this.formData = {
            evProjectID: this.evProjectInput.getValue("value"),
            activityStatusID: this.activityStatusInput.getValue(),
            bookingStatusID: this.bookingStatusInput.getValue(),
            evRoomID: this.roomInput.getValue("value"),
            copyEvCast: this.cbEvCast.getValue(),
            copyEvProgram: this.cbEvProgram.getValue(),
            copyEvServiceBookings: this.cbEvService.getValue(),
            copyEvTasks: this.cbEvTask.getValue(),
            sourceBookingID: this._sourceBooking.ID,
            bookingTitle: this.bookingTitleInput.getValue(),
            targetDates: []
        };

        for (let set of this.datesRegistry) {
            this.formData.targetDates.push({
                dateStart: this.dateToLocalISOString(set.dateSet.dateStart),
                dateEnd: this.dateToLocalISOString(set.dateSet.dateEnd),
                isFulltime: set.dateSet.isFulltime
            });
        }

        let result = this.validate();
        this.emit("result", result);

        if (this.dlg) this.dlg._setOkBtnAttr(true, result);

        console.log("serializeData", this.formData);
    }

    getData() {
        return this.formData;
    }

    private validate(): boolean {
        let result: boolean = true;

        this.UiModder.domClass.toggle(this.sectionTargetDates, "warningBG", !this.formData.targetDates.length);

        if (!this.activityStatusInput.validateInput()) result = false;
        if (!this.bookingStatusInput.validateInput()) result = false;
        if (!this.bookingTitleInput.validateInput()) result = false;
        if (!this.roomInput.validateInput()) result = false;

        if (!this.formData) result = false;

        if (!this.formData.targetDates || !this.formData.targetDates.length) result = false;

        if (!this.evProjectInput.validateInput()) result = false;

        this.datesRegistry.forEach(entry => {
            this.UiModder.domClass.remove(entry.row.rows[0].node, "warningBG round");

            if (this.datesRegistry.filter(x => x.dateSet.dateStart < entry.dateSet.dateEnd && x.dateSet.dateEnd > entry.dateSet.dateStart).length > 1) {

                this.UiModder.domClass.add(entry.row.rows[0].node, "warningBG round");
                result = false;
            }
        });

        return result;
    }

    private drawDatesetTable(): void {

        this.UiModder.domConstruct.empty(this.datesetContainer);

        this.datesTable = new StaticTable();
        this.datesTable.placeAt(this.datesetContainer);

        this.datesTable.keyAttribute = "guid";

        this.datesTable.setVerticalAlign("middle");

        let tableRowLayout: StaticTable.RowConfig = {
            attributes: ["dateSet.dateStart", "dateSet.dateEnd", "dateSet.isFulltime"],
            colNamesInternal: ["dateStart", "dateEnd", "isFulltime"],
            headings: [
                this.translations["EvBookingditor_dateStart_inputLabel"],
                this.translations["EvBookingditor_dateEnd_inputLabel"],
                this.translations["General_Label_IsFullTime"],
               /* this.translations["General_Label_Actions"]*/""],
            colspans: [1, 1, 1],
            widths: [null, null, "10ch"],
            alignmentsRow: [null, null, null],
            alignmentsHeading: [null, null, null]
        };


        this.datesTable.addCustomRowActionButton("warning", lang.hitch(this, this._onClick_Warning), "paddingSmall fas fa-exclamation-triangle warningTXT", null, null, null, false);
        this.datesTable.addCustomRowActionButton("nowarning", lang.hitch(this, this._onClick_Warning), "paddingSmall w3-text-green fas fa-check", null, null, null, false);

        this.datesTable.enableActionButton("warning", null, false, true);
        this.datesTable.enableActionButton("nowarning", null, false, false);

        this.datesTable.addDefaultRowActionButton("delete", lang.hitch(this, this._onClick_RemoveDateSet));

        this.datesTable.addLineConfig(tableRowLayout);

        this.datesTable.setFormatter(lang.hitch(this, this._tableFormatter));

        this.datesTable.setData(this.datesRegistry, "guid");

        this.datesTable.setCyAttribute("copyFormDates");

        for (let entry of this.datesRegistry) {
            this._checkEnableWarning(entry);
        }
    }



    private setOverlappingViewParametersForEntry(entry: DateSetRegistry): void {

        let entity = entry.dateSet;

        let dateEnd: Date =entity.dateEnd;

        try {
            if (entity.isFulltime) {
                dateEnd = new Date(entity.dateStart.valueOf());
                dateEnd.setHours(23, 59, 59);
            }
        } catch (ex) {
            console.warn(this.id + " setting overlapping request data for fulltime failed", entry, ex);
        }

        try {
            this.datesTable.enableActionButton("warning", entry, false, "current");
            this.datesTable.enableActionButton("nowarning", entry, false, "current");
        } catch (ex) {

        }

        entry.overlappingView.setup({
            start: entity.dateStart,
            end: dateEnd,
            roomId: this.roomInput.getValue("value"),
            selfBookingId: null,
            isWithRoomList: false
        });
    }
    private _tableFormatter(cell: StaticTable.StaticTableCell<DateSetRegistry>): boolean {

        let cellname = cell.name;

        let regEntry: DateSetRegistry = cell.tableRow.rowGroup.entity;

        regEntry.row = cell.tableRow.rowGroup;

        switch (cellname) {
            case "actions":
                let btn = this.UiModder.domConstruct.create("button", {
                    className: "mds-button-base round hoverBright deleteBtn",
                    innerHTML: this.createFontawesomeIcon("fas fa-trash warningTXT").outerHTML
                }, cell.tableCellNode);

                on(btn, "click", lang.hitch(this, this._onClick_RemoveDateSet, cell.tableRow.rowGroup.rowIndex));



                return true;

                break;

            case "dateStart":
                let inputDs = new DateTimeInput();
                inputDs.setValue(cell.entity.dateSet.dateStart, true);
                inputDs.placeAt(cell.tableCellNode);

                if (cell.entity.dateSet.isFulltime === true) {
                    inputDs.useTimeInput(false);
                }

                on(inputDs, "change", lang.hitch(this, this._onChangeTblCellValue, cell, regEntry));

                regEntry.inputDateStart = inputDs;
                return true;
                break;

            case "dateEnd":
                let inputDe = new DateTimeInput();
                inputDe.setValue(cell.entity.dateSet.dateEnd, true);
                inputDe.placeAt(cell.tableCellNode);

                if (cell.entity.dateSet.isFulltime === true) {
                    inputDe.useTimeInput(false);
                    inputDe.setReadonly(true);
                    inputDe.setValue(cell.entity.dateSet.dateStart, true);
                }
                else {
                    on(inputDe, "change", lang.hitch(this, this._onChangeTblCellValue, cell, regEntry));
                }

                regEntry.inputDateEnd = inputDe;
                return true;
                break;

            case "isFulltime":

                let inputFt = new CheckBox();
                inputFt.setValue(cell.entity.dateSet.isFulltime, true);
                inputFt.placeAt(cell.tableCellNode);
                on(inputFt, "change", lang.hitch(this, this._onChangeTblCellValue, cell, regEntry));

                regEntry.inputFulltime = inputFt;
                return true;
                break;
        }

        return false;
    }
    private _onClick_Warning(rowgroup: StaticTable.StaticTableRowGroup<DateSetRegistry>) {
        let reg = rowgroup.entity;
        this._onClick_OverlappingDetails(reg);
    }
    private _onClick_OverlappingDetails(entry: DateSetRegistry) {
        if (entry.overlappingDlg == null) {
            entry.overlappingDlg = new GenericDialog();
        }
        entry.overlappingDlg.setCloseOnEscape(true);
        entry.overlappingDlg.set("closeBtn", true);
        entry.overlappingDlg.set("header", this.translations["RoomBlockingForm__Label_Overlappings"]);
        entry.overlappingDlg.addNodeToContent(entry.overlappingView.domNode);
        entry.overlappingDlg.destroyOnClose = false;
        entry.overlappingDlg.show();
    }

    private _onOverlappingDataReceived(regEntry: DateSetRegistry, overlappingData: Array<object>) {

        this._checkEnableWarning(regEntry);
    }
    private _checkEnableWarning(regEntry: DateSetRegistry) {
        if (!this.hasFeature("EvBooking/Overlappings")) {
            this.datesTable.enableActionButton("warning", regEntry, false, false);
            this.datesTable.enableActionButton("nowarning", regEntry, false, false);
        } else {
            if (regEntry.overlappingView) {
                if (regEntry.overlappingView.getOverlappingsCount() > 0) {
                    this.datesTable.enableActionButton("warning", regEntry, true, true);
                    this.datesTable.enableActionButton("nowarning", regEntry, false, false);
                } else if (regEntry.overlappingView.getOverlappingsCount() == 0) {
                    this.datesTable.enableActionButton("warning", regEntry, false, false);
                    this.datesTable.enableActionButton("nowarning", regEntry, true, true);
                }

            }
        }
    }

    private _onClick_RemoveDateSet(rowgroup: StaticTable.StaticTableRowGroup<any>) {
        let index = rowgroup.rowIndex;
        //this.datesRegistry.splice(index, 1);

        //this.drawDatesetTable();

        this.delayedSerializeData();
    }

    private _onChangeTblCellValue(cell: StaticTable.StaticTableCell<DateSetRegistry>, registryEntry: DateSetRegistry) {

        let entity = cell.entity.dateSet;
        let targetProperty = cell.name;

        switch (targetProperty) {
            case "isFulltime":
                let isFulltime = registryEntry.inputFulltime.getValue() as boolean;
                entity.isFulltime = isFulltime;

                registryEntry.inputDateStart.useTimeInput(!isFulltime);
                registryEntry.inputDateEnd.useTimeInput(!isFulltime);
                registryEntry.inputDateEnd.setReadonly(isFulltime);

                break;

            case "dateStart":
                let newDateStartValue = (registryEntry.inputDateStart as MdsLax<InstanceType<typeof DateTimeInput>>).getValue();
                if (newDateStartValue.date != null && newDateStartValue.date instanceof Date) {
                    let originalValue = registryEntry.dateSet.dateStart.valueOf();
                    let diff = newDateStartValue.date.valueOf() - originalValue;
                    let originalEndValue = entity.dateEnd.valueOf();

                    //console.log("_onChangeTblCellValue", newDateStartValue);
                    entity.dateStart = newDateStartValue.date;
                    entity.dateEnd = new Date(originalEndValue + diff);

                    registryEntry.inputDateEnd.setValue(entity.dateEnd, true);
                }
                break;

            case "dateEnd":
                let dateValue = (registryEntry.inputDateEnd as MdsLax<InstanceType<typeof DateTimeInput>>).getValue();
                if (dateValue.date != null && dateValue.date instanceof Date) {
                    entity[targetProperty] = dateValue.date;
                }
                break;


            default:

                break;
        }

        if (entity.dateStart && entity.dateEnd) {
            try {
                if (!entity.isFulltime) {
                    if (entity.dateStart.valueOf() > entity.dateEnd.valueOf()) {
                        entity.dateEnd = entity.dateStart;
                        this.datesTable.updateEntity(entity, cell.tableRow.rowGroup.rowIndex);
                    }
                } else {
                    registryEntry.inputDateEnd.useTimeInput(!entity.isFulltime);
                    registryEntry.inputDateEnd.setReadonly(entity.isFulltime);
                    registryEntry.inputDateEnd.setValue(registryEntry.dateSet.dateStart, true);
                    //this.datesTable.updateEntity(entity, cell.tableRow.rowGroup.rowIndex);
                }
            } catch (ex) {

            }
            if (registryEntry.overlappingView) {
                this.setOverlappingViewParametersForEntry(registryEntry);
            }
        }

        //console.debug("_onChangeTblCellValue", targetProperty, entity, cell);
        this.delayedSerializeData();

        //this.drawDatesetTable();
    }

    setupFromID(entityID: string) {
        if (!entityID) {
            alert("tried setting up copyform without entityID!");
            return;
        }

        this.setupDlg(null);

        this.StandbyStart();
        this.disableNode(this.domNode);
        let data = { ID: entityID };

        this.RequestManager.callfunction("Webtool_API_EvBooking__GetEntityById",
            data,
            lang.hitch(this, this._onLoadEntityResult),
            lang.hitch(this, this._onLoadEntityError)
        );
    }
    private _onLoadEntityResult(result: VAM2types.EvBooking_Base) {

        if (typeof (result.date_start) == "string") {
            (<any>result).date_start = new Date(result.date_start);
        }
        if (typeof (result.date_end) == "string") {
            (<any>result).date_end = new Date(result.date_end);
        }

        this.StandbyStop();
        this.disableNode(this.domNode, false);
        this.setup(result);
    }
    private _onLoadEntityError(error: more.requestErrorMessage) {
        this.StandbyStop();
        alert(error.Message);
    }

    private setupDlg(label: string, destroy?: boolean): MdsLax<InstanceType<typeof GenericDialog>> {
        if (this.dlg) {

            if (destroy === true) {
                try {
                    this.dlg.destroy();
                } catch (ex) {

                }

                this.dlg = null;
            }
        }


        if (!this.dlg) {

            this.dlg = new GenericDialog();

            this.dlg.show(this,
                this.translate("BookingEditor__CopyEvBooking"),
                null, null,
                "okcancel",
                lang.hitch(this, this._onCloneDlgResult));
        }

        let dlg = this.dlg;
        dlg._setHeaderAttr(this.translate("BookingEditor__CopyEvBooking") + (label ? " - " + label : ""));

        dlg._setOkBtnAttr(true, false);

        dlg.keepOpen = true;

        dlg.show();


        return this.dlg;
    }
    setup(sourceBooking: VAM2types.EvBooking_Base) {


        if (!sourceBooking) return;

        this._sourceBooking = {
            ID: sourceBooking.ID,
            dateStart: sourceBooking.date_start,
            dateEnd: sourceBooking.date_end,
            ref_ev_activity_status: sourceBooking.ref_ev_activity_status,
            ref_ev_booking_status: sourceBooking.ref_ev_booking_status,
            fullTime: sourceBooking.is_full_time
        };

        this.startup();

        this.handleAvailableFeatures();

        let currentBookingTitle = sourceBooking.ev_booking_name;

        //console.debug("_startCloneProcess", this.existingEntity); return;
        let dlg = this.setupDlg(currentBookingTitle, false);

        if (this.translations["BookingEditor__CopyTitleFormat"]) {
            this.bookingTitleInput.setValue(this.stringFormat(this.translations["BookingEditor__CopyTitleFormat"], sourceBooking.ev_booking_name));
        } else {
            this.bookingTitleInput.setValue(sourceBooking.ev_booking_name);
        }


        this.bookingStatusInput.setValue(sourceBooking.ref_ev_booking_status.ID);
        this.activityStatusInput.setValue(sourceBooking.ref_ev_activity_status.ID);

        this.roomInput.setValue(sourceBooking.ref_ev_room);
        this.evProjectInput.setValue(sourceBooking.ref_ev_project);

        this.headingText.innerHTML = sourceBooking.gDisp_1 ? sourceBooking.gDisp_1 : "?";

        this.addDateSet();
    }

    private handleAvailableFeatures() {

        this.hideNode(this.containerEvCast, !this.hasFeature("EvBooking/EvCast"));
        this.hideNode(this.containerEvProgram, !this.hasFeature("EvBooking/EvProgram"));
        this.hideNode(this.containerEvTask, !this.hasFeature("EvBooking/EvTask"));
        this.hideNode(this.containerEvService, !this.hasFeature("EvBooking/EvService"));

        let module: {
            presets: {
                'EvProgram': boolean
                'EvCast': boolean,
                'EvService': boolean,
                'EvTask': boolean
            }
        } = this.getModule("EvBookingCopyform");

        if (module && module.presets) {

            console.debug(this.id + " presets from appsettings", module);

            // unlogisch, die Settings müssen eigentlich aus EvBooking/ kommen, sonst wärs womöglich widersprüchlich
            //this.hideNode(this.containerEvCast, !this.hasFeature("EvBookingCopyform/EvCast"));
            //this.hideNode(this.containerEvProgram, !this.hasFeature("EvBookingCopyform/EvProgram"));
            //this.hideNode(this.containerEvTask, !this.hasFeature("EvBookingCopyform/EvTask"));
            //this.hideNode(this.containerEvService, !this.hasFeature("EvBookingCopyform/EvService"));

            if (typeof (module.presets.EvProgram) == "boolean") {
                this.cbEvProgram.setValue(module.presets.EvProgram);
            }
            if (typeof (module.presets.EvCast) == "boolean") {
                this.cbEvCast.setValue(module.presets.EvCast);
            }
            if (typeof (module.presets.EvService) == "boolean") {
                this.cbEvService.setValue(module.presets.EvService);
            }
            if (typeof (module.presets.EvTask) == "boolean") {
                this.cbEvTask.setValue(module.presets.EvTask);
            }

        }
    }

    private _onCloneDlgResult(result: number) {

        if (result <= 0) {
            this.dlg.close(-1, true);
            return;
        }

        let data: VAM2types.CopyFormData_EvBooking = this.getData();

        console.log("_onCloneDlgResult", data);
        this.dlg.disableAllButtons(true);
        this.StandbyStart(this.dlg.contentContainer);

        this.RequestManager.callfunction("Webtool_API_EvBooking__CopyEvBooking",
            data,
            lang.hitch(this, this._onCopyBookingResponse),
            lang.hitch(this, this._onCopyBookingError)
        );

    //    this.RequestManager.post(
    //        window.appRoot + "EvBookingEditor/CopyEvBooking", // ?! "Calendar/GetItemDetails" ?!
    //        {
    //            "jsonData": JSON.stringify(data)
    //        },
    //        lang.hitch(this, this._onCopyBookingResponse),
    //        lang.hitch(this, this._onCopyBookingError)
    //    );
    }

    private _onCopyBookingResponse(response: VAM2types.EvBookingCopyFormResponse<any>) {
        this.StandbyStop();

        if (response.result == "success") {
            this.dlg.destroyOnClose = false;
            this.dlg.close(1, true);

            let buttonConfigs = [];
            if (response.resultBookings?.length == 1) {
                buttonConfigs.push({

                    label: this.translations["CopyForm_SaveSuccess_ShowResult"],
                    callback: lang.hitch(this, this._showCopyResult, response.resultBookings)
                });
            }
            this.showToast({
                title: this.translations["CopyForm_SaveSuccess"],
                iconClass: ToasterHelpers.ToasterIcons.confirmCheck,
                options: {

                    timeout: 15000,
                    buttons: buttonConfigs
                }
            })

            this.emit("saved", response.resultBookings);

            setTimeout(lang.hitch(this, this.destroy, 30000));
        }

        else {
            //this.setOverlappingResults(response);
            if (response.message) {
                this.showToast({
                    title: response.message,
                    iconClass: ToasterHelpers.ToasterIcons.warning
                });
            }
            this.dlg.disableAllButtons(false);
        }
    }

    private _showCopyResult(bookings: Array<VAM2types.EvBooking_Base>) {
        console.debug(this.id + " showResult", bookings);

        for (let entry of bookings) {
            let view = new EvBookingView;
            view.setup(entry.ID, entry.ev_booking_name);
        }
    }

    private _onCopyBookingError(error: more.requestErrorMessage) {
        alert("Copy Booking: " + error.Message);
        console.error(error.Message);
        this.showToast({
            title: "Error copy booking",
            message: error.Message,
            iconClass: ToasterHelpers.ToasterIcons.error
        });
        this.dlg.disableAllButtons(false);
        this.StandbyStop();
    }

    private setOverlappingResults(response: VAM2types.EvBookingCopyFormResponse<any>) {
        if (response.result != "success") {

        }
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.datesRegistry = [];


    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvBookingCopyForm);
